import { DOCUMENT } from '@angular/common';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { from, Observable, of, throwError } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';
import { AuthService } from '../services/auth/auth.service';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(
    private authenticationService: AuthService,
    @Inject(DOCUMENT) private document: Document
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err) => {
        if (err.status !== 401 || !this.authenticationService.isAuthenticated()) {
          return throwError(err);
        }

        return from(this.authenticationService.logout()).pipe(
          catchError(() => of(false)),
          mergeMap(sharedCleanupSucceeded => {
            if (sharedCleanupSucceeded) {
              this.document.defaultView?.location.reload();
            }
            return throwError(err);
          })
        );
      })
    );
  }
}
